<template>
    <div>
        <component :is="this.headerFooter.header"></component>
        <div class="container">
            <ReportInfo :reportInfo="reportInfo"/>
            <ReportChart style="margin-top:60px;" />
            <div style="margin-top:100px;">
                <b-button variant="outline-secondary" size="lg" @click="changeFeatur1(0)">Single Original</b-button>
                <b-button variant="outline-secondary" size="lg" @click="changeFeatur1(1)" style="margin-left:20px;">Single PSD</b-button>
                <b-button variant="outline-secondary" size="lg" @click="changeFeatur1(2)" style="margin-left:20px;">Single FFT</b-button>
            </div>
            <SingleReportChart v-if="is_showSingleOriginal" />
            <SingleReportPSD v-if="is_showSinglePSD" :type="type1" :key="timer1"/>
            <SingleReportFFT v-if="is_showSingleFFT" :type="type1" :key="timer1"/>
        </div>
    </div>
</template>
<script>
import Header from '@/components/Header.vue';
import ReportInfo from '@/components/sp_report/report_info.vue'
import ReportChart from '@/components/rm_report/report_chart.vue'
import SingleReportChart from '@/components/rm_report/single_report_chart.vue'
import SingleReportPSD from '@/components/rm_report/single_report_psd.vue'
import SingleReportFFT from '@/components/rm_report/single_report_fft.vue'
import store from "@/store"
export default {
    data() {
        return {
            client_account: '',
            report_id: '',
            doc_account: 'cherng0125',
            type1: '',
            timer:null,
            timer1:null,
            is_showSingleOriginal: true,
            is_showSinglePSD: false,
            is_showSingleFFT: false
        }
    },
    components: {
        Header,
        ReportInfo,
        ReportChart,
        SingleReportChart,
        SingleReportPSD,
        SingleReportFFT
    },
    created(){
        const report = JSON.parse(sessionStorage.getItem('client_report'));
        const user = JSON.parse(sessionStorage.getItem('my_info'));
        if(user === null){
            alert("请重新登入");
            this.$router.push('/login');
        }
        this.reportInfo = report
    },
    computed: {
        headerFooter() {
            return store.getters['auth/isLoggedIn'] ? {
                header: Header,
            } : {
                header: Header,
            }
        },
    },
    methods: {
        changeFeatur1(tag) {
            if(tag === 0) {
                this.is_showSingleOriginal = true
                this.is_showSinglePSD = false
                this.is_showSingleFFT = false
            }else if(tag === 1){
                this.is_showSingleOriginal = false
                this.is_showSinglePSD = true
                this.is_showSingleFFT = false
                this.type1 = 1
                this.timer1 = new Date().getTime();
            }else if(tag === 2) {
                this.is_showSingleOriginal = false
                this.is_showSinglePSD = false
                this.is_showSingleFFT = true
                this.type1 = 1
                this.timer1 = new Date().getTime();
            }
        }
    }
}
</script>